"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _eventemitter = require("eventemitter3");

var _eventemitter2 = _interopRequireDefault(_eventemitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BufferedEventEmitter = function (_EventEmitter) {
	_inherits(BufferedEventEmitter, _EventEmitter);

	function BufferedEventEmitter() {
		_classCallCheck(this, BufferedEventEmitter);

		var _this = _possibleConstructorReturn(this, (BufferedEventEmitter.__proto__ || Object.getPrototypeOf(BufferedEventEmitter)).call(this));

		_this._pendingEvents = [];
		return _this;
	}

	_createClass(BufferedEventEmitter, [{
		key: "emit",
		value: function emit(event, data) {
			var hasListeners = _get(BufferedEventEmitter.prototype.__proto__ || Object.getPrototypeOf(BufferedEventEmitter.prototype), "emit", this).call(this, event, data);
			if (!hasListeners) this._pendingEvents.push({ event: event, data: data });
			return hasListeners;
		}
	}, {
		key: "on",
		value: function on(event, listener) {
			_get(BufferedEventEmitter.prototype.__proto__ || Object.getPrototypeOf(BufferedEventEmitter.prototype), "on", this).call(this, event, listener);

			var isPending = function isPending(it) {
				return it.event === event;
			};
			this._pendingEvents.filter(isPending).forEach(function (_ref) {
				var event = _ref.event,
				    data = _ref.data;
				return listener(data);
			});
			this._pendingEvents = this._pendingEvents.filter(function (it) {
				return !isPending(it);
			});

			return this;
		}
	}]);

	return BufferedEventEmitter;
}(_eventemitter2.default);

exports.default = BufferedEventEmitter;